/* eslint-disable no-param-reassign */
function name(file) {
  return file.path.split(/[\\/]/g).pop();
}

function extension(file) {
  return (/[.]/.exec(file.path)) ? /[^.]+$/.exec(file.path)[0] : undefined;
}

function depth(file) {
  return (file.path.match(/[\\/]/g) || []).length;
}

function slicePath(file, initial, final) {
  if (initial > depth(file)) {
    return null;
  }
  return file.path.split(/[\\/]/g).slice(initial, final + 1).join('/');
}

function at(file, depthAt) {
  return !!slicePath(file, depthAt, depthAt);
}

function inside(parent, child) {
  if (!child && !child.path) {
    return true;
  }

  return child.path.startsWith(parent.path);
}

const fileTreeMapper = (currentDepth) => {
  return (file) => {
    const current = {
      directory: depth(file) > currentDepth,
      path: slicePath(file, 0, currentDepth),
    };

    current.name = name(current);
    current.extension = extension(current);
    return current;
  };
};

function loadChildrenForRoot(files) {
  return files.map(fileTreeMapper(0));
}

function loadChildrenForNonRoot(files, current) {
  const childrensDepth = depth(current) + 1;

  const filterAtDepthAndInside = (file) => {
    return at(file, childrensDepth) && inside(current, file);
  };

  return files
    .filter(filterAtDepthAndInside)
    .map(fileTreeMapper(childrensDepth));
}

function removeDuplicated(files) {
  return files.filter((file, index, self) => {
    return self.findIndex(fp => fp.path === file.path) === index;
  });
}

const sort = (a, b) => {
  let valueA = a.directory ? '0' : '1';
  valueA += a.path;
  let valueB = b.directory ? '0' : '1';
  valueB += b.path;
  if (valueA < valueB) {
    return -1;
  }
  if (valueA > valueB) {
    return 1;
  }
  return 0;
};

function treeify(files, current = null) {
  const isRoot = !current;
  let children = null;

  if (isRoot) {
    children = loadChildrenForRoot(files);
  } else {
    children = loadChildrenForNonRoot(files, current);
  }

  children = removeDuplicated(children);
  children.sort(sort);

  children.forEach((child) => {
    if (child.directory) {
      child.children = treeify(files, child);
    }
  });

  return children;
}

function pathOnlyFiles(files) {
  if (!files) {
    return [];
  }

  return files.map((file) => {
    return {
      path: file.path,
    };
  });
}

function generate(files) {
  return treeify(pathOnlyFiles(files));
}

export default {
  generate,
};
